import React, { Fragment, useState, useEffect } from 'react';
import { LogIn, User, Bell } from 'react-feather';
import { setTranslations, setDefaultLanguage, setLanguageCookie, translate } from 'react-switch-lang';
import { Account, LogOut } from '../../constant'
import { IndexNotificationsMicrosite } from "../notifications/IndexNotificationsMicrosite";
import { ToastAletGlobal } from '../../views/alertDialog/ToastAletGlobal';
import { useMicrositePatients } from '../../hooks/micrositioCompany/useMicrositePatients';

import en from '../../assets/i18n/en.json';
import es from '../../assets/i18n/es.json';
import pt from '../../assets/i18n/pt.json';
import fr from '../../assets/i18n/fr.json';
import du from '../../assets/i18n/du.json';
import cn from '../../assets/i18n/cn.json';
import ae from '../../assets/i18n/ae.json';
import { useClientNotifications } from '../../hooks/notification/useClientNotifications';
import { cedimi } from '../../constant/globalConstantsTypeClients';
setTranslations({ en, es, pt, fr, du, cn, ae });
setDefaultLanguage('en');
setLanguageCookie();


const Rightbar = (props) => {
  const [moonlight, setMoonlight] = useState(false)
  // const [notificationDropDown, setNotificationDropDown] = useState(false)

  useEffect(() => {
    if (localStorage.getItem("layout_version") === "dark-only") {
      setMoonlight(true)
    }
  }, []);

  const {

      notifications,
      loading,
      refreshNotifications:getNotifications,
      markAsRead,
      unreadCount,

      //? TOAS ALERT
      showToast, toastType, toastTitle, toastMessage, closeToastAlert,
      
      //? REFRESH
      refreshing, clearNewNotifications, newNotifications, printWorkOrder, loadingDownloadPdf

  } = useClientNotifications();

  const {
    previewWorkOrderPDF,
    modalPreviewPDF, setModalPreviewPDF, pdfPreviewUrl, setPdfPreviewUrl, loadingPdfPreview

  } = useMicrositePatients();



  const handleCloseNotifications = () => {
      setVisibleRight(false);
      clearNewNotifications();
  };


  //Mode Moonligth
  const MoonlightToggle = (light) => {
    if (light) {
      setMoonlight(!light)
      document.body.className = "light"
      localStorage.setItem('layout_version', 'light');
    } else {
      setMoonlight(!light)
      document.body.className = "dark-only"
      localStorage.setItem('layout_version', 'dark-only');
    }
  }

  const cerrarSesion = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("empresa");

    window.location.replace(`${process.env.PUBLIC_URL}/micrositio`);
  };


  const [nameUser, setNameUser] = useState("User");
  const [roleUser, setRoleUser] = useState("Normal")


  useEffect(() => {
    localStorage.getItem("nameUser") !== null && setNameUser(localStorage.getItem("nameUser").toUpperCase());
    localStorage.getItem("companyName") !== null && setRoleUser(localStorage.getItem("companyName").toUpperCase());
  }, []);

    let url_helen = localStorage.getItem('url_helen');


  const [visibleRight, setVisibleRight] = useState(false);
  // console.log("🔔 notifications", notifications);
  // console.log("🔔 Es arreglo:", Array.isArray(notifications));
  //datos del micrositio del paciente que es mostrar los datos
  return (
    <Fragment>
      <div className="nav-right col-8 pull-right right-header p-0">
        <ul className="nav-menus">
          <li>
            <div className="mode text-white" onClick={() => MoonlightToggle(moonlight)}><i className={`fa ${moonlight ? 'fa-lightbulb-o' : 'fa-moon-o'}`}></i></div>
          </li>

        {url_helen === cedimi && (

         <li className="profile-nav onhover-dropdown p-0">

            <div
                onClick={() => setVisibleRight(true)}
                className="cursor-pointer"
            >

              <div className="notification-box text-white">

                    <Bell />

                    {unreadCount > 0 && (
                        <span className="notification-counter">
                            {unreadCount > 99 ? "99+" : unreadCount}
                        </span>
                    )}

                </div>

            </div>

        </li>
        )}

        
          
        {url_helen === cedimi && (

          <IndexNotificationsMicrosite
            visibleRight={visibleRight}
            setVisibleRight={setVisibleRight}
            notifications={notifications}
            loading={loading}
            markAsRead={markAsRead}
            refreshing={refreshing}
            handleCloseNotifications={handleCloseNotifications}
            newNotifications={newNotifications}
            printWorkOrder={printWorkOrder}
            previewWorkOrderPDF={previewWorkOrderPDF}
            loadingPdfPreview={loadingPdfPreview}
            setPdfPreviewUrl={setPdfPreviewUrl}
            pdfPreviewUrl={pdfPreviewUrl}
            setModalPreviewPDF={setModalPreviewPDF}
            modalPreviewPDF={modalPreviewPDF}
            loadingDownloadPdf={loadingDownloadPdf}

          />
        )}


          <li className="profile-nav onhover-dropdown p-0">

            <div className="media profile-media">
              {/* <img className="b-r-10" src={man} alt="" />  modificar profile-media img de 70px    */}
              <div className="media-body"><span>{nameUser}</span>
                <p className="mb-0 font-roboto">{roleUser} <i className="middle fa fa-angle-down"></i></p>
              </div>
            </div>


            <ul className="profile-dropdown onhover-show-div">
              <li><User /><span>{Account} </span></li>
              <li onClick={cerrarSesion}><LogIn /><span>{LogOut}</span></li>
            </ul>
          </li>
        </ul>
      </div>
      {url_helen === cedimi && (

        <ToastAletGlobal
              visible={showToast}
              type={toastType}
              title={toastTitle}
              message={toastMessage}
              onClose={closeToastAlert}
          />
      )}
    </Fragment>
    
  );
}
export default translate(Rightbar);